import { Routes } from '@angular/router';

const title = 'Seguridad';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'usuario-app',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Usuarios' }] },
        loadComponent: () => import('./pages/usuario-app-lista/usuario-app-lista.component'),
      },
    ],
  },
];
